/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { httpV2 } from "@/api/index";
import WDService from "@/services/wind/diagnostic/WindDiagnosticService";
import { SetLayoutLinesColor } from "@/components/charts/ChartStyles";
import {
	GET_HSS_MISALIGNMENT_DIAGNOSTIC,
	GET_HSS_MISALIGNMENT_DIAGNOSTIC_SUCCESS,
	GET_HSS_MISALIGNMENT_DIAGNOSTIC_ERROR,

} from "@/stores/actions/HSSMisalignmentDiagnostic";

const state = {
	status:               FetchStatus.Init,
	isParallelAndAngular: false,
	orderData:            {},
	frequencyData:        {},
	orderLayout:          {},
	frequencyLayout:      {},
	error:                {},
};

const actions = {
	[GET_HSS_MISALIGNMENT_DIAGNOSTIC]: ({ commit }, parameters) =>
	{
		commit(GET_HSS_MISALIGNMENT_DIAGNOSTIC);

		const misalignmentChartDataMapping = {
			PAR: {
				url:      "ParallelMisalignmentHSS/Chart",
				propData: "parallelMisalignmentHSSChartData"
			},
			ANG: {
				url:      "AngularMisalignmentHSS/Chart",
				propData: "angularMisalignmentHssChartData"
			}
		};
    
		const apiRoute = `/WindTurbinesDiagnostic/${parameters.resultSetId}/
		${misalignmentChartDataMapping[parameters.title].url}`;

		httpV2.get(apiRoute)
			.then((resp) =>
			{
				const diagnosticChartDataProp = misalignmentChartDataMapping[parameters.title].propData;
				const orderChartData = WDService.CreateChart(resp.data[diagnosticChartDataProp], true);
				const frequencyChartData = WDService.CreateChart(resp.data[diagnosticChartDataProp], false);

				const orderLayout = SetLayoutLinesColor(WDService.OrderLayoutModel(), parameters.isDarkMode);
				orderLayout.shapes = WDService.CreateShapes(resp.data.concernOrders);
				orderLayout.annotations =
					WDService.CreateAnnotationText(resp.data.concernOrders, parameters.isDarkMode, parameters.locationName);

				const frequencyLayout = SetLayoutLinesColor(WDService.FrequencyLayoutModel(), parameters.isDarkMode);
				frequencyLayout.shapes = WDService.CreateShapes(resp.data.concernFrequencies);
				frequencyLayout.annotations = WDService.CreateAnnotationText(
					resp.data.concernFrequencies,
					parameters.isDarkMode,
					parameters.locationName,
				);

				const response = {
					orderChartData,
					frequencyChartData,
					orderLayout,
					frequencyLayout,
					isParallelAndAngular: resp.data.isAngularAndParallelMisaligment,
				};
				commit(GET_HSS_MISALIGNMENT_DIAGNOSTIC_SUCCESS, response);
			})
			.catch((error) =>
			{
				commit(GET_HSS_MISALIGNMENT_DIAGNOSTIC_ERROR, error.response);
			});
	},
};

const mutations = {
	[GET_HSS_MISALIGNMENT_DIAGNOSTIC]: (state) =>
	{
		state.status = FetchStatus.Loading;
	},
	[GET_HSS_MISALIGNMENT_DIAGNOSTIC_SUCCESS]: (state, resp) =>
	{
		state.isParallelAndAngular = resp.isParallelAndAngular;
		state.orderData = resp.orderChartData;
		state.frequencyData = resp.frequencyChartData;
		state.orderLayout = resp.orderLayout;
		state.frequencyLayout = resp.frequencyLayout;
		state.status = FetchStatus.Loaded;
	},
	[GET_HSS_MISALIGNMENT_DIAGNOSTIC_ERROR]: (state, error) =>
	{
		state.error = error.response;
		state.status = FetchStatus.Error;
	},
};

export default {
	state,
	actions,
	mutations,
};
